export function header($) {

  //----------------------------------------------------
  // TOGGLE  MENU
  //----------------------------------------------------

  $('.js--toggle-menu').click(function(e) {
    e.preventDefault();
    $('body').toggleClass('menuVisible');
  });

  //----------------------------------------------------
  // TOGGLE  SEARCH
  //----------------------------------------------------

  $('.js--toggle-search').click(function(e) {
    e.preventDefault();
    $('body').toggleClass('searchVisible');
  });

}
